import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import { Echo } from "@/lib/echo";
import { useFetchMe } from "@/user/services";
import { useTenant } from "@/user/services/tenant";

import { conversations, messages } from "../services";
import { type Conversation, type Message } from "../types";

export function usePrivateUserChannel() {
  const { data: user } = useFetchMe();
  const tenant = useTenant();

  const queryClient = useQueryClient();

  useEffect(() => {
    if (!user?.id) return;

    Echo.private(`${tenant.id}.messenger.chat.private.${user.id}`)
      .listen(".Messenger.MessageCreated", ({}: { message: Message }) => {
        // #TODO we need optimistically update the cache here
        queryClient.invalidateQueries({
          queryKey: messages._def,
        });
        queryClient.invalidateQueries({
          queryKey: conversations._def,
        });
        queryClient.invalidateQueries(conversations.unreadCount);
      })
      .listen(
        ".Messenger.ConversationUpdated",
        ({}: { conversation: Conversation<false, false, false> }) => {
          queryClient.invalidateQueries({
            queryKey: conversations._def,
          });

          queryClient.invalidateQueries(conversations.unreadCount);

          queryClient.invalidateQueries({
            queryKey: messages._def,
          });
        },
      );

    return () => {
      Echo.leave(`${tenant.id}.messenger.chat.private.${user.id}`);
    };
  }, [user?.id, tenant.id, queryClient]);
}
